import { resumo_de_alunos_por_deficiencia } from "./resumo-de-alunos-por-deficiencia/index";
import { cadastro_de_turma_de_atendimento_educacional_especializado } from "./cadastro-de-turma-de-atendimento-educacional-especializado/index";
import { matricula_de_aluno_de_atendimento_educacional_especializado } from "./matricula-de-turma-de-atendimento-educacional-especializado/index";
import { consulta_de_aluno_de_atendimento_educacional_especializado } from "./consulta-de-aluno-de-atendimento-educacional-especializado/index";
const aluno_com_deficiencia = [
  ...resumo_de_alunos_por_deficiencia,
  ...cadastro_de_turma_de_atendimento_educacional_especializado,
  ...matricula_de_aluno_de_atendimento_educacional_especializado,
  ...consulta_de_aluno_de_atendimento_educacional_especializado,
];

export { aluno_com_deficiencia };
